module.exports = __webpack_public_path__ + "img/close-icon.1a1b65f5.svg";